module.exports = __webpack_public_path__ + "media/images/icons/single-54fd3c30fbc0983dcf4cd8e8f7568f91.png";